"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jquery_1 = __importDefault(require("jquery"));
var qs_1 = __importDefault(require("qs"));
/* Javascript functionality for the expand years button. */
jquery_1.default(function () {
    var $thCurrent = jquery_1.default('th.current');
    var $thCurrentA = $thCurrent.find('a').first();
    var $thYearNotCurrent = jquery_1.default('th.year:not(.current)');
    var $tdYearNotCurrent = jquery_1.default('td.year:not(.current)');
    var $tdPlaceholder = jquery_1.default('<td class="empty"></td>');
    var $expand = '<span class="expand-button-text">Se tidigare år</span><i class="fas fa-plus"></i>';
    var $collapse = '<i class="fas fa-minus"></i>';
    var $button = jquery_1.default('<th class="expand-button"></th>');
    if ($thCurrent.prev().hasClass('hidden')) {
        $button.append($expand);
    }
    else {
        $button.append($collapse);
    }
    $button.click(function () {
        var qp = qs_1.default.parse(window.location.search.substring(1));
        if (qp['years_hide_previous'] === 'false') {
            $thYearNotCurrent.css('display', 'none');
            $tdYearNotCurrent.css('display', 'none');
            qp['years_hide_previous'] = true;
            $button.empty().append($expand);
        }
        else {
            $thYearNotCurrent.css('display', 'table-cell');
            $tdYearNotCurrent.css('display', 'table-cell');
            qp['years_hide_previous'] = false;
            $button.empty().append($collapse);
        }
        window.history.replaceState({}, "", "?" + qs_1.default.stringify(qp));
        var href = $thCurrentA.attr('href');
        if (href) {
            var _a = href.split('?'), pre = _a[0], q = _a[1];
            var hrefQP = qs_1.default.parse(q);
            hrefQP['years_hide_previous'] = qp['years_hide_previous'];
            $thCurrentA.prop('href', pre + '?' + qs_1.default.stringify(hrefQP));
        }
    });
    if (jquery_1.default('.rankings-index').length !== 0) {
        // Big rankings page
        $button = $button.insertAfter('.rankings-index th.name');
        // on big ranking page the CSS class is name
        $tdPlaceholder.insertAfter('.rankings-index td.name');
    }
    else if (jquery_1.default('#municipality-ranking').length !== 0) {
        // Municipalities ranking page
        $button = $button.insertAfter('#municipality-ranking th.name');
        // on muni ranking page the CSS class is muni
        $tdPlaceholder.insertAfter('#municipality-ranking td.muni');
    }
});
